import React from 'react'
import Invoice from "../../nav/invoice";

class AssignmentRowProcessed extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoice: props.invoice,
            invoiceItem: props.invoiceItem,
            keyIndex: props.keyIndex,
            invoiceIndex: props.invoiceIndex,
            itemIndex: props.itemIndex,
            isFirst: props.itemIndex === 0,
            showInvoice: false,
        };
    }

    onShowInvoice = () => {
        this.setState({
            showInvoice: !this.state.showInvoice,
        })
    }

    onSetBookKeepingNumber = (event) => {
        this.props.onSetBookKeepingNumber(this.state.invoiceIndex, this.state.itemIndex, event.target.value);
    };

    deleteInvoiceItem = () => {
        this.props.deleteInvoiceItem(this.state.keyIndex);
        this.props.notifyError('A tétel törölve lett a kimenetből');
    }

    deleteInvoice = () => {
        this.props.deleteInvoice(this.props.invoiceIndex);
        this.props.notifyError('A számla törölve lett a kimenetből');
    }


    render() {
        return (
            <React.Fragment>
                <tr key={this.state.key} className={this.state.isFirst ? 'border-top-2' : ''}>
                    <td>{this.state.invoice.supplier.name}</td>
                    <td>
                        <a onClick={(event) => this.onShowInvoice()} title="Számlakép">
                            {this.state.invoice.invoiceNumber}
                        </a>
                    </td>
                    <td>{this.state.invoiceItem.name}</td>
                    <td>
                        <input
                            name='main_bookkeeping_number'
                            value={this.state.invoiceItem.main_bookkeeping_number_custom || this.state.invoiceItem.main_bookkeeping_number}
                            onChange={(event) => this.onSetBookKeepingNumber(event)}
                            className='bordered-input'
                            type='text'
                        />
                    </td>
                    <td>{parseInt(this.state.invoiceItem.vatPercentage * 100, 0)}%</td>
                    <td>{this.state.invoiceItem.vat_collector_title}</td>
                    <td>{this.state.invoiceItem.vat_degree}</td>
                    <td>
                        <i onClick={(event) => this.deleteInvoiceItem()} title='Tétel törlése a kimenetből' className='fa fa-trash-o' aria-hidden='true'></i> &nbsp;
                        <i onClick={(event) => this.deleteInvoice()} title='Számla törlése a kimenetből' className='fa fa-trash' aria-hidden='true'></i>
                    </td>
                </tr>
                {this.state.showInvoice
                    ? <tr>
                        <td colSpan="8">
                            <Invoice
                                {...this.props}
                                invoice={this.state.invoice}
                            />
                        </td>
                    </tr>
                    : null}
            </React.Fragment>
        );
    }
}

export default AssignmentRowProcessed


// WEBPACK FOOTER //
// ./src/components/supplier/steps/AssignmentRowProcessed.js